import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Table,
  Thead,
  Th,
  Tbody,
  Tr,
  Td
} from '@chakra-ui/react';

export function OpsLiberadas({ ops }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!ops) {
    return null;
  }

  const formattedOpsDynamic = Object.entries(ops).map(([key, value]) => {
    return {
      key,
      value
    };
  });

  return (
    <>
      <Button onClick={onOpen}>Ops Liberadas</Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>OP'S Liberadas</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Table>
              <Thead>
                <Th>Mês</Th>
                <Th>Quantidade</Th>
              </Thead>
              <Tbody>
                {formattedOpsDynamic.map((item) => {
                  return (
                    <Tr key={item.key}>
                      <Td>{item.key}</Td>
                      <Td>{item.value}</Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
